import React from "react";
import { SvgIcon } from '@material-ui/core';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 223,
    height: 120
  }
});

class MybilioTextLogoBronze extends React.Component {

  render() {
    const { classes, className } = this.props;

    return <SvgIcon className = { clsx(classes.root, className) }
                    titleAccess = 'Mybilio'
                    viewBox = { "0 0 223 120" } >
      <path d="M92.7529 116.1L88.447 94.6601L80.6314 116.354H80.2696L72.4177 94.6601L68.1481 116.1H66.6646L71.9473 90.4591H72.3454L80.4505 113.058L88.5556 90.4591H88.9536L94.2364 116.1H92.7529Z" fill="#004876"/>
      <path d="M108.963 107.155V116.1H107.515V107.155L98.3972 90.7488H100.062L108.239 105.815L116.417 90.7488H118.081L108.963 107.155Z" fill="#004876"/>
      <path d="M136.814 102.338C138.37 101.179 139.274 99.4044 139.274 97.3039C139.274 93.8634 136.85 90.7488 131.857 90.7488H124.873V116.1H133.159C138.333 116.1 141.047 112.515 141.047 108.821C141.047 105.778 139.383 103.461 136.814 102.338ZM131.639 94.1169C134.245 94.1169 135.801 95.5655 135.801 97.6298C135.801 99.6217 134.208 101.288 131.603 101.288H128.311V94.1169H131.639ZM132.906 112.732H128.311V104.692H132.906C135.801 104.692 137.465 106.43 137.465 108.676C137.465 110.921 135.764 112.732 132.906 112.732Z" fill="#004876"/>
      <path d ="M149.481 116.1H152.918V90.7488H149.481V116.1Z" fill="#004876"/>
      <path d="M165.971 112.732V90.7488H162.534V116.1H175.343V112.732H165.971Z" fill="#004876"/>
      <path d="M182.442 116.1H185.879V90.7488H182.442V116.1Z" fill="#004876"/>
      <path d="M207.616 116.571C215.468 116.571 220.606 110.487 220.606 103.424C220.606 96.3985 215.468 90.3142 207.616 90.3142C199.728 90.3142 194.59 96.3985 194.59 103.424C194.59 110.487 199.728 116.571 207.616 116.571ZM207.616 113.167C201.899 113.167 198.1 108.603 198.1 103.424C198.1 98.2455 201.899 93.7185 207.616 93.7185C213.297 93.7185 217.169 98.2455 217.169 103.424C217.169 108.603 213.297 113.167 207.616 113.167Z" fill="#004876"/>
      <path d ="M2.39783 31.803V93.417L52.4769 117.717V114.663H52.4499V59.286L102.559 31.572L51.5747 2.39999L51.5597 10.584V12.033V55.941L2.39783 31.803ZM52.4529 55.926V6.186L96.7562 31.596L52.4529 55.926ZM5.39514 36.615L51.5537 59.283V113.91L5.39514 91.545V36.615Z" fill="#004876"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(MybilioTextLogoBronze);